<template>
    <div class="table-layout">
        <el-table :data="bizDepartComList" border style="width: 100%" v-if="bizDepartComList.length > 0" ref="swb_hop_device_stcok_check_voucher_for_pdf">
            <el-table-column align="left" prop="fullName" label="下属部门"></el-table-column>
            <el-table-column align="left" prop="state" label="当前状态" width="120">
                <template slot-scope="rows">
                    <span>{{ orgStateMap[rows.row.state] || '' }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="是否通过" width="100">
                <template slot-scope="rows">
                    <span class="font-red" v-if="rows.row.state != closedState">未通过</span>
                    <span v-else>通过</span>
                </template>
            </el-table-column>
        </el-table>
        <el-table :data="bizUnitComList" border style="width: 100%; margin-top: 10px" v-if="bizUnitComList.length > 0">
            <el-table-column align="left" prop="fullName" label="下属业务单元"></el-table-column>
            <el-table-column align="left" prop="state" label="当前状态" width="120">
                <template slot-scope="rows">
                    <span>{{ orgStateMap[rows.row.state] || '' }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="是否通过" width="100">
                <template slot-scope="rows">
                    <span class="font-red" v-if="rows.row.state != closedState">未通过</span>
                    <span v-else>通过</span>
                </template>
            </el-table-column>
        </el-table>

        <div ref="swb_org_attr_check_dlg" v-show="false">
            <table class="simple-tbl"
                   style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
                <thead class="head">
                <tr class="row" style="height:40px;">
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align:center; font-size:14px; ">组织类型</td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align:center; font-size:14px; ">部门全称</td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align:center; font-size:14px; ">状态</td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align:center; font-size:14px;">未通过原因</td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align:center; font-size:14px; ">处理方式</td>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="(checkResutlInfo, index) in checkResultComList">
                    <template v-if="index == 0 || checkResutlInfo.id != checkResultComList[index - 1].id">
                        <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;" :rowspan='checkResutlInfo.checkResultList.length'>
                            <span v-if="checkResutlInfo.orgType == 0">业务部门</span>
                            <span v-else>业务单元</span>
                        </td>
                        <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;" :rowspan='checkResutlInfo.checkResultList.length'>
                            <span>{{ checkResutlInfo.fullName || '' }}</span>
                        </td>
                        <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;" :rowspan='checkResutlInfo.checkResultList.length'>
                            <span>{{ orgStateMap[checkResutlInfo.state] || '' }}</span>
                        </td>
                    </template>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <span>{{ checkResutlInfo.warnMsg || '' }}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <span>{{ checkResutlInfo.handleMsg || '' }}</span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>

<script>
import { Utils } from '../../app.base'
//
export default {
    name: 'swb-check-com-state-list',
    desc: '停业中-->已停业：检查下级机构状态',
    props: ['comList'],
    data: function () {
        return {
            orgStateMap: getEnumMap('orgState', 'value2text'),
            closedState: getEnumInfoWith('orgState', 'name', 'Closed').value,
            bizUnitComList: [],
            bizDepartComList: [],
            checkResultComList: []
        }
    },
    created: function () {
        let comList = this.comList || [];
        for(let i = 0; i < comList.length; i++) {
            let comInfo = comList[i];
            if(comInfo.orgType == 1) {
                this.bizUnitComList.push(comInfo);
            } else {
                this.bizDepartComList.push(comInfo);
            }
            //
            // if(comInfo.checkResultList != null && comInfo.checkResultList.length > 0) {
            //     this.checkResultComList.push(comInfo);
            // }
            if(comInfo.checkResultList != null && comInfo.checkResultList.length > 0) {
                for(let j = 0; j < comInfo.checkResultList.length; j++) {
                    comInfo.warnMsg = comInfo.checkResultList[j].warnMsg || '';
                    comInfo.handleMsg = comInfo.checkResultList[j].handleMsg || '';
                    this.checkResultComList.push(Utils.merge({}, comInfo));
                }
            }
        }
    },
    methods: {
        checkComStateList: function () {
            return this.$refs.swb_org_attr_check_dlg.innerHTML || '';
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/orgStruct/checkComStateList.vue